// extracted by mini-css-extract-plugin
export default {"center":"Center_center__cr5to"};